import { render } from "./NewSprintModal.vue?vue&type=template&id=2c337545&scoped=true"
import script from "./NewSprintModal.vue?vue&type=script&lang=js"
export * from "./NewSprintModal.vue?vue&type=script&lang=js"

import "./NewSprintModal.vue?vue&type=style&index=0&id=2c337545&scoped=true&lang=scss"
import "./NewSprintModal.vue?vue&type=style&index=1&id=2c337545&lang=scss"
script.render = render
script.__scopeId = "data-v-2c337545"

export default script